<template lang="html">

<div class="mdl-color--white mdl-shadow--2dp mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop" style="padding: 20px;">
    <h3>About the Data</h3>
    <div v-html="about(sharedState.metadata)"></div>
</div>




</template>

<script>
import scrollTo from '../modules/scrollto';
import {metaAbout, metaImportant, metaResources} from '../modules/meta.js';
import fetchData from '../modules/fetch.js';

export default {
    name: 'sc-aboutdata',
    watch: {
      'privateState.model.metricId': 'fetch'
    },
    methods: {
        about: function(data) {
            return metaAbout(data);
        },
        fetch: function() {
            fetchData(this.sharedState, this.privateState.model.metricId.replace('m', ''));
            scrollTo(document.querySelector('.mdl-layout__content'), 0, 600);
        }
    }
};
</script>
